<template>
  <div class="footer">
    <div class="footer-content">
      <div class="item">
        <!-- <div class="footer-logo">
          
        </div> -->
        <img class="footer-logo" src="../../../assets/images/shaoxing/footer-logo.png" alt="">
        <div class="tip">
          帮助中心 | 常见问题 | 法律声明 | 服务协议
        </div>
      </div>
      <div class="item">
        <p>
          <span class="version-right">绍兴旅游股份有限公司©版本所有 <a href="http://beian.miit.gov.cn/?spm=a21bo.21814703.1997523009.44.5af911d9s7b6aU" target="_blank">浙ICP备19043518号-1</a>  技术支持： 深大科技</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    },
  },
}
</script>

<style scoped lang="scss">
.footer{
  width: 100%;
  background: #F0F0F0;
  .footer-content {
    width: 1200px;
    height: 100px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    .item {
      flex: 1;
      .footer-logo {
        display: inline-block;
        width: 40px;
        vertical-align: middle;
      }
      .tip {
        display: inline-block;
        padding-left: 10px;
        font-size: 12px;
        color: #999;
      }
      p {
        font-size: 12px;
        color: #999;
        text-align: right;
      }
    }
  }  
}
</style>


// WEBPACK FOOTER //
// src/pages/shaoxing/components/footer.vue